

export const days = [
    {value: "day-1", label: "1"},
    {value: "day-2", label: "2"},
    {value: "day-3", label: "3"},
    {value: "day-4", label: "4"},
    {value: "day-5", label: "5"},
    {value: "day-6", label: "6"},
    {value: "day-7", label: "7"},
    {value: "day-8", label: "8"},
    {value: "day-9", label: "9"},
    {value: "day-10", label: "10"},
    {value: "day-11", label: "11"},
    {value: "day-12", label: "12"},
    {value: "day-13", label: "13"},
    {value: "day-14", label: "14"},
    {value: "day-15", label: "15"},
    {value: "day-16", label: "16"},
    {value: "day-17", label: "17"},
    {value: "day-18", label: "18"},
    {value: "day-19", label: "19"},
    {value: "day-20", label: "20"},
    {value: "day-21", label: "21"},
    {value: "day-22", label: "22"},
    {value: "day-23", label: "23"},
    {value: "day-24", label: "24"},
    {value: "day-25", label: "25"},
    {value: "day-26", label: "26"},
    {value: "day-27", label: "27"},
    {value: "day-28", label: "28"},
    {value: "day-29", label: "29"},
    {value: "day-30", label: "30"},
    {value: "day-31", label: "31"},
]

export const months = [
    {value: "month-1", label: "Ocak"},
    {value: "month-2", label: "Şubat"},
    {value: "month-3", label: "Mart"},
    {value: "month-4", label: "Nisan"},
    {value: "month-5", label: "Mayıs"},
    {value: "month-6", label: "Haziran"},
    {value: "month-7", label: "Temmuz"},
    {value: "month-8", label: "Ağustos"},
    {value: "month-9", label: "Eylül"},
    {value: "month-10", label: "Ekim"},
    {value: "month-11", label: "Kasım"},
    {value: "month-12", label: "Aralık"},
]

export const years = [
    {value: "year-2020", label: "2020"},
    {value: "year-2019", label: "2019"},
    {value: "year-2018", label: "2018"},
    {value: "year-2017", label: "2017"},
    {value: "year-2016", label: "2016"},
    {value: "year-2015", label: "2015"},
    {value: "year-2014", label: "2014"},
    {value: "year-2013", label: "2013"},
    {value: "year-2012", label: "2012"},
    {value: "year-2011", label: "2011"},
    {value: "year-2010", label: "2010"},
    {value: "year-2009", label: "2009"},
    {value: "year-2008", label: "2008"},
    {value: "year-2007", label: "2007"},
    {value: "year-2006", label: "2006"},
    {value: "year-2005", label: "2005"},
    {value: "year-2004", label: "2004"},
    {value: "year-2003", label: "2003"},
    {value: "year-2002", label: "2002"},
    {value: "year-2001", label: "2001"},
    {value: "year-2000", label: "2000"},
    {value: "year-1999", label: "1999"},
    {value: "year-1998", label: "1998"},
    {value: "year-1997", label: "1997"},
    {value: "year-1996", label: "1996"},
    {value: "year-1995", label: "1995"},
    {value: "year-1994", label: "1994"},
    {value: "year-1993", label: "1993"},
    {value: "year-1992", label: "1992"},
    {value: "year-1991", label: "1991"},
    {value: "year-1990", label: "1990"},
    {value: "year-1989", label: "1989"},
    {value: "year-1988", label: "1988"},
    {value: "year-1987", label: "1987"},
    {value: "year-1986", label: "1986"},
    {value: "year-1985", label: "1985"},
    {value: "year-1984", label: "1984"},
    {value: "year-1983", label: "1983"},
    {value: "year-1982", label: "1982"},
    {value: "year-1981", label: "1981"},
    {value: "year-1980", label: "1980"},
    {value: "year-1979", label: "1979"},
    {value: "year-1978", label: "1978"},
    {value: "year-1977", label: "1977"},
    {value: "year-1976", label: "1976"},
    {value: "year-1975", label: "1975"},
    {value: "year-1974", label: "1974"},
    {value: "year-1973", label: "1973"},
    {value: "year-1972", label: "1972"},
    {value: "year-1971", label: "1971"},
    {value: "year-1970", label: "1970"},
    {value: "year-1969", label: "1969"},
    {value: "year-1968", label: "1968"},
    {value: "year-1967", label: "1967"},
    {value: "year-1966", label: "1966"},
    {value: "year-1965", label: "1965"},
    {value: "year-1964", label: "1964"},
    {value: "year-1963", label: "1963"},
    {value: "year-1962", label: "1962"},
    {value: "year-1961", label: "1961"},
    {value: "year-1960", label: "1960"},
    {value: "year-1959", label: "1959"},
    {value: "year-1958", label: "1958"},
    {value: "year-1957", label: "1957"},
    {value: "year-1956", label: "1956"},
    {value: "year-1955", label: "1955"},
    {value: "year-1954", label: "1954"},
    {value: "year-1953", label: "1953"},
]